var React = require('react');

function DifficultyLevelBlack (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Level Dimond Black"),React.createElement("rect",{"fill":"#000","x":"5.6","y":"5.6","width":"27.05","height":"27.05","transform":"translate(-7.92 19.12) rotate(-45)","key":1})]);
}

DifficultyLevelBlack.defaultProps = {"role":"presentation","viewBox":"0 0 38.25 38.25"};

module.exports = DifficultyLevelBlack;

DifficultyLevelBlack.default = DifficultyLevelBlack;
